import type { CommandData } from '../types'

export function unmount() {
  const message: CommandData = {
    isFromNetwatch: true,
    command: 'unmount',
  }
  window.postMessage(message)
}
